import AlternativeTable from '../../components/payroll_components/AlternativeTable';

import Box from '@mui/material/Box';

export const TerritoryManagerDash = () => {
    return (
        <div className='tm-dash-container'>
            <Box className='tm-dash-content'
            display= "flex"
            alignItems="center"
            marginLeft={10}
            >
                <AlternativeTable />
            </Box>
        </div>
    );
}